module.exports = __webpack_public_path__ + "img/line.ed3bcf9f.svg";